import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer, DtpNoContent, DtpButton } from 'dtp-react-components';
import {
  Table,
  Button,
} from '../../components/index';
import {
  doGet,
  buscaDestinatarios,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import * as constantes from '../../utils/constants';
import FiltroBloqueioDesbloqueio from './FiltroBloqueioDesbloqueio';
// import { manterApenasFiltro } from '../../utils/helpers';
import { formatarCnpj } from '../../utils/helpers';

class ConsultaBloqueio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaBloqueiosFiltrada: null,
      listaBloqueiosIndexada: [],
      bloqueioVindoDoRequest: null,
      tipoBloqueioSelecionado: null,
      showNoContent: false,
      listaBloqueiosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      complemento: '',
      filtrosPesquisa: {},
      existeCompetenciaInicial: true,
      competenciaAberta: null,
      participante: {
        codigo: null,
        tipoRegime: null,
        nome: null,
        cnpj: null,
        cnpjEf: null,
        tipoRegimeProprio: null,
        uf: null,
      },
    };
  }

  componentDidMount() {
    // manterApenasFiltro('filtroBloqueio');
    sessionStorage.removeItem('filtroBloqueio');

    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }

    this.buscaCompetenciaPagamentoAberta();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };

    this.setState({
      listaBloqueiosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  lotacao = this.props.auth.userData.lotacoes[0];

  buscaDadosParticipanteSuccess = (response) => {
    this.setState({
      participante: { ...response.data },
    });
  };

  handleErrorDadosParticipante = (error) => {
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          this.state.participante.cnpj = null;
          this.state.participante.uf = null;
          this.setState({
            showNoContent: false,
            listaBloqueiosIndexada: [],
            listaBloqueiosIndexadaAtualizada: true,
            noContentPrimaryMessage: 'Ente Federativo não encontrado para o cnpj informado.',
            noContentSecondaryMessage: 'Informe um cnpj válido.',
          });
        }
      }
    }
  };

  buscaDadosParticipante = (codigo) => {
    doGet(`participantes-compensacao/codigo/${codigo}`, this.buscaDadosParticipanteSuccess, this.handleErrorDadosParticipante);
  }

  buscaDadosCompetenciaPagamentoSuccess = (response) => {
    let objCompetencia = response.data.competencia;
    if (objCompetencia.length !== 7) {
      objCompetencia = `0${objCompetencia}`;
    }
    this.setState({
      competenciaAberta: objCompetencia,
    });
  };

  handleErrorDadosCompetenciaPagamento = () => {
    this.setState({
      existeCompetenciaInicial: false,
    });
  };

  buscaCompetenciaPagamentoAberta = () => {
    doGet(
      'fechamento-pagamentos/pagamento-aberto',
      this.buscaDadosCompetenciaPagamentoSuccess,
      this.handleErrorDadosCompetenciaPagamento,
    );
  }

  realizaConsulta = (filtrosPesquisa) => {
    // params estados[]: int , cpf : string,
    // tipoRequerimento: 1 || 2, participacao: 1 || 2, atributoOrdenacao: string
    // let { participante } = { ...this.state.participante };
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
      if (filtrosPesquisa['destinatario-rpps'] !== null) {
        this.buscaDadosParticipante(filtrosPesquisa['destinatario-rpps']);
      }
      // if (filtrosPesquisa['destinatario-rpps'] === null) {
      //   participante = null;
      // }
    }
    this.setState(
      {
        ...this.state,
        filtrosConsulta,
      },
      this.executaConsulta,
    );
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'bloqueios',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaBloqueiosIndexada: [], listaBloqueiosIndexadaAtualizada: true });
    }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = [];
    if (atributosPesquisa['destinatario-rpps']) {
      atributos = { ...atributos, 'destinatario-rpps': atributosPesquisa['destinatario-rpps'] };
    }
    if (atributosPesquisa.competenciaAberta) {
      atributos = { ...atributos, competenciaAberta: atributosPesquisa.competenciaAberta };
    }
    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  verificaAtributosParaConsulta = () => {
    if (this.getTipoConsulta()) {
      return constantes.estadosParaConsulta[this.getTipoConsulta()];
    }
    return null;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaBloqueiosIndexada: [],
        listaBloqueiosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaBloqueiosIndexada: response.data,
        listaBloqueiosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaBloqueiosFiltrada) => {
    this.setState({ listaBloqueiosFiltrada, listaBloqueiosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Ente não encontrado para o cnpj informado.',
            noContentSecondaryMessage: 'Informe um cnpj válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }

  showBloqueioDesbloqueio = (bloqueio) => {
    const data = bloqueio.dataInclusaoBloqueio;
    const dataSplit = data.split('/');
    const dia = dataSplit[0];
    const mes = dataSplit[1];
    const ano = dataSplit[2];
    let primeiraParte = this.state.participante.codigo;

    if (this.state.participante.codigo === null || this.state.filtrosConsulta.competenciaAberta) {
      primeiraParte = bloqueio.idParticipante;
    }

    const chave = `${primeiraParte}${dia}${mes}${ano}`;
    this.props.history.push(`/cadastros/entesFederativos/bloqueio/desbloquear-ente/${chave}/${bloqueio.mesInicioBloqueio}/${bloqueio.anoInicioBloqueio}/${bloqueio.tipoBloqueio}`);
  }

  montaAcoes = (row, tipo, possuiPermissaoDesbloqueio) => (
    <Button
      hint={tipo}
      // icon={row.dataEncerramentoBloqueio ? 'ico-doc-magnifier' : 'ico-doc-pencil'}
      icon={(!row.dataEncerramentoBloqueio && possuiPermissaoDesbloqueio) ? 'ico-doc-pencil' : 'ico-doc-magnifier'}
      mini
      onClick={() => this.showBloqueioDesbloqueio(row)}
    />
  );

  // Motivos de Desbloqueio x Usuários
  // Código Descrição         Usuário
  // 1      CND               GESTOR_DCOMP
  // 2      Aluguel           GESTOR_DCOMP
  // 3      Judicial          GESTOR_DCOMP|ANALISTA_SPREV|ANALISTA_CONTRATO_DTP
  // 4      Contrato Dataprev ANALISTA_CONTRATO_DTP
  // 5      Inadimplência     GESTOR_DCOMP
  // TABELA BLOQUEIOS
  // Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
  // CS_TIPO_BLOQUEIO Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
  // Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
  // CS_TIPO_DESBLOQUEIO Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência

  verificarPermissaoDesbloqueio = (row) => {
    let possuiPermissaoDesbloqueio = false;
    switch (row.tipoBloqueio) {
      case 1: // CND
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 2: // JUDICIAL
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp', 'analisar-negocio-sprev'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 3: // ALUGUEL
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 4: // Contrato Dataprev
        if (this.props.auth.checkPermission(['analisar-contrato-dtpv'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      case 5: // Inadimplência
        if (this.props.auth.checkPermission(['gerenciar-negocio-dcomp', 'analisar-negocio-sprev'])) {
          possuiPermissaoDesbloqueio = true;
        }
        break;
      default:
        break;
    }
    return possuiPermissaoDesbloqueio;
  }

  createActionColumn = (cell, row) => {
    const possuiPermissaoDesbloqueio = this.verificarPermissaoDesbloqueio(row);

    // let hint = 'Desbloquear o ente federativo';
    let hint = '';
    if (row.dataEncerramentoBloqueio || !possuiPermissaoDesbloqueio) {
      hint = 'Visualizar o ente federativo';
    }

    if (!row.dataEncerramentoBloqueio && possuiPermissaoDesbloqueio) {
      hint = 'Desbloquear o ente federativo';
    }

    return this.montaAcoes(row, hint, possuiPermissaoDesbloqueio);
  };

  addMotivoBloqueioDesloqueioLabel = (tipo) => {
    let valor = '';
    if (tipo) {
      valor = listUtils.getObject(listUtils.motivosBloqueio, tipo).label;
    }
    return valor;
  }
  formatarCompetencia = (competenciaInicioBloqueio) => {
    let valor = '';
    if (competenciaInicioBloqueio) {
      if (competenciaInicioBloqueio.length === 6) {
        valor = `0${competenciaInicioBloqueio}`;
      } else {
        valor = competenciaInicioBloqueio;
      }
    }
    return valor;
  }

  colunasDefault = [
    {
      id: 'competenciaInicioBloqueio',
      label: 'Competência Inicial',
      dataFormat: this.formatarCompetencia,
    },
    {
      id: 'competenciaFimBloqueio',
      label: 'Competência Final',
      dataFormat: this.formatarCompetencia,
    },
    {
      id: 'tipoBloqueio',
      label: 'Motivo do Bloqueio',
      dataFormat: this.addMotivoBloqueioDesloqueioLabel,
    },
    {
      id: 'tipoDesbloqueio',
      label: 'Motivo do Desbloqueio',
      dataFormat: this.addMotivoBloqueioDesloqueioLabel,
    }];

    colunasDefaultCompetenciaAberta = [
      {
        id: 'nomeParticipante',
        label: 'Participante',
      }, {
        id: 'cnpj',
        label: 'CNPJ',
      },
      {
        id: 'competenciaInicioBloqueio',
        label: 'Competência Inicial',
        dataFormat: this.formatarCompetencia,
      },
      {
        id: 'competenciaFimBloqueio',
        label: 'Competência Final',
        dataFormat: this.formatarCompetencia,
      },
      {
        id: 'tipoBloqueio',
        label: 'Motivo do Bloqueio',
        dataFormat: this.addMotivoBloqueioDesloqueioLabel,
      },
      {
        id: 'tipoDesbloqueio',
        label: 'Motivo do Desbloqueio',
        dataFormat: this.addMotivoBloqueioDesloqueioLabel,
      }];

  montaColunas = () => {
    let bloqueiosTableHeader = this.colunasDefault.slice();

    if (this.state.filtrosConsulta) {
      if (this.state.filtrosConsulta.competenciaAberta &&
        !this.state.filtrosConsulta['destinatario-rpps']) {
        bloqueiosTableHeader = this.colunasDefaultCompetenciaAberta.slice();
      }
    }
    bloqueiosTableHeader.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    return bloqueiosTableHeader;
  }

  alterarPagina = (pagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  newCadastroBloqueio = () => {
    // this.props.history.push('/cadastros/entesFederativos/bloqueio/novo');
    const { filtroBloqueio } = { ...this.props };
    let paramFiltroBloqueio = filtroBloqueio;
    if (paramFiltroBloqueio !== null) {
      paramFiltroBloqueio = JSON.parse(filtroBloqueio);
      const paramDestinatario = paramFiltroBloqueio['destinatario-rpps'];
      const paramTipoEntidade = paramFiltroBloqueio.tipoEntidade;
      const paramUf = paramFiltroBloqueio.uf;
      this.props.history.push(`/cadastros/entesFederativos/bloqueio/novo/
        ${paramTipoEntidade}/${paramUf}/${paramDestinatario}`);
    } else {
      this.props.history.push('/cadastros/entesFederativos/bloqueio/novo');
    }
  }

  montaComplemento = () => {
    const { participante } = { ...this.state };
    const { filtrosConsulta } = { ...this.state };
    const { competenciaAberta } = { ...this.state };
    let complemento = '';

    if (filtrosConsulta) {
      if (competenciaAberta && filtrosConsulta['destinatario-rpps']) {
        if (participante) {
          let ufEnte = '';
          let cnpjEnte = '';
          if (participante.uf !== '') {
            ufEnte = `- ${participante.uf}`;
          }
          if (participante.cnpjEf !== undefined) {
            cnpjEnte = `- CNPJ: ${formatarCnpj(participante.cnpjEf)}`;
          }
          complemento = `${cnpjEnte} ${ufEnte} - ${participante.nome}`;
          return complemento;
        }
      } else {
        complemento = `- até a competência: ${competenciaAberta}`;
        return complemento;
      }
    }
    return complemento;
  }

  verificaSeCampoDesabilitado = () => {
    const { existeCompetenciaInicial } = { ...this.state };
    if (existeCompetenciaInicial === false) {
      return true;
    }
    return false;
  };

  render() {
    const options = {
      noDataText: 'Nenhum bloqueio a ser exibido',
      hideSizePerPage: true,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const bloqueiosTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroBloqueioDesbloqueio
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            destinatarios={this.props.destinatarios}
            list={this.state.listaBloqueiosIndexada}
            tipoConsulta={this.getTipoConsulta()}
            listaBloqueiosIndexadaAtualizada={this.state.listaBloqueiosIndexadaAtualizada}
            existeCompetenciaInicial={this.state.existeCompetenciaInicial}
            competenciaAberta={this.state.competenciaAberta}
          />
          <Table
            legend={`Bloqueio / Desbloqueio do Ente Federativo ${this.montaComplemento()}`}
            bordered
            fetchInfo={fetchInfo}
            data={this.state.listaBloqueiosIndexada}
            options={options}
            listaTableHeader={bloqueiosTableHeader}
            pagination
            remote
          />
          <DtpButton
            disabled={this.verificaSeCampoDesabilitado()}
            className="dtp-primary right"
            title="Adicionar Bloqueio"
            accessibilityName="Adicionar Bloqueio"
            onClick={() => this.newCadastroBloqueio()}
          />
        </DtpContentContainer>
      )
    );
  }
}

ConsultaBloqueio.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      chave: PropTypes.string,
      mes: PropTypes.string,
      ano: PropTypes.string,
      tipo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  filtroBloqueio: PropTypes.shape({
    'destinatario-rpps': PropTypes.string,
    tipoEntidade: PropTypes.string,
    uf: PropTypes.string,
    competenciaAberta: PropTypes.string,
  }),
};


ConsultaBloqueio.defaultProps = {
  match: null,
  auth: null,
  destinatarios: [],
  filtroBloqueio: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  filtroBloqueio: state.base.filtroBloqueio,
});

export default connect(mapStateToProps)(ConsultaBloqueio);



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaBloqueio.jsx